import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { products } from '../../../../../redux/products/action';
import { selectProductsQueryItems } from '../../../../../redux/products/selector';
import ProductComponent from '../components/product.component';
import { selectProductTypesListItems } from '../../../../../redux/product-types/selector';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { categories } from '../../../../../redux/categories/action';
import { productTypes } from '../../../../../redux/product-types/action';

const ManagementProduct = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
 const CategoryLists = useSelector(selectCategoriesListItems)
 const ProductTypeLists = useSelector(selectProductTypesListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const productsQuery = useSelector(selectProductsQueryItems)
  const [
    selectedProducts,
    setSelectedProducts
  ] = useState<any>([])

  const fetchProductsQueryById= ()=>{
    dispatch(products.query({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products/query`,entity:'products',jsonData:{
          
    Records: [
      {
              "Id": parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
}).then(()=>{
  setIsLoading(false)
})
  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedProducts({ ...selectedProducts, [field]: event })
  }

  useEffect(
    () => {
        dispatch(categories.list({
            url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,
            entity: 'categories',
            jsonData: {}
    })).then(()=>{
        dispatch(productTypes.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types/list`,entity:'productTypes',jsonData:{}
        }))
    }).then(()=>{
      if (parmas?.id > 0) {
        fetchProductsQueryById()
        setIsLoading(false)
      }else {
        setIsLoading(false)
      }
    })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedProducts(productsQuery?.result?.items)
      
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
  
    if (parmas?.id > 0) {
     dispatch(products.update({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products`,entity:'products',jsonData:{
          
    Records: [
        selectedProducts
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      dispatch(products.create({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products`,entity:'products',jsonData:{
          
      Records: [
        selectedProducts
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/taxonomy/products')
} 
    return (
      <>
     {isLoading ? <PageLoader /> : 
     
    
          <ProductComponent 
          selectedProducts={selectedProducts}
          Categories={CategoryLists?.result?.items}
          productTypes={ProductTypeLists?.result?.items}
          onInnerBasicFormChange={handleInnerbasicFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
          />  
     }
     
           </>
    )
    
    }
   
    export default ManagementProduct;